<template lang="pug">
  .dropdown(:class="{ 'is-active': activeDropdown, 'selected': isSelected }")
    .dropdown-trigger
      button.button(@click="getData" :disabled="disabled")
        span {{ selectedItem.name || labelText }}
    .dropdown-menu#dropdown-menu(role="menu")
      .dropdown-content(v-if="items")
        a.dropdown-item(
          v-for="item in items"
          @click="selectItem(item)") {{ item.name}}
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { gettext } from '@/services/TranslateHandler'

export default {
  data () {
    return {
      selectedItem: '',
      activeDropdown: false,
      items: null,
      isSelected: false
    }
  },
  props: {
    type: {
      default: 'country'
    },
    labelText: {
      default: 'Country'
    },
    countryCode: {
      default: ''
    },
    disabled: {
      default: false
    }
  },
  methods: {
    gettext: gettext,
    ...mapActions([
      'receiveCountries',
      'receiveRegions'
    ]),
    getData (lang, country) {
      this.activeDropdown = !this.activeDropdown
      if (this.type === 'country') {
        this.receiveCountries(this.getLanguage).then(res => {
          this.items = res
        })
      } else if (this.type === 'region') {
        this.receiveRegions({ lang: this.getLanguage, country: this.countryCode }).then(res => {
          this.items = res
        })
      }
    },
    selectItem (item) {
      this.activeDropdown = !this.activeDropdown
      this.selectedItem = item
      this.$emit('input', item)
      this.isSelected = true
    }
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ])
  },
  watch: {
    getLanguage: function () {
      this.$emit('input', '')
      this.selectedItem = ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/location-dropdown/index.vue